import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import * as settingsActions from "../../../Estore/_redux/Estore/basicSettingsAction";

export function useDragColumnSync({
  type,
  subType,
  columns,
  selectedColumns,
  setSelectedColumns,
  isDragged,
  setIsDragged,
  columnSelection,
  setColumnSelection,
  pinnedCount,
  validate_columns,
  useKeyedStore = false,
}) {
  const dispatch = useDispatch();
  const getColumnListing = useKeyedStore ? settingsActions.getDragColumnListingByKey : settingsActions.getDragColumnListing;
  const setColumnListing = useKeyedStore ? settingsActions.setDragColumnListingByKey : settingsActions.setDragColumnListing;
  const filterSelectedColumns = (columnList = []) => {
    const allowedDataIndexes = new Set((columns || []).map((column) => column?.dataIndex));
    return columnList?.filter((column) => allowedDataIndexes.has(column?.dataIndex)) || [];
  };

  // Keep refs so isDragged/columnSelection effects always read the latest values
  const selectedColumnsRef = useRef(selectedColumns);
  const pinnedCountRef = useRef(pinnedCount);
  useEffect(() => {
    selectedColumnsRef.current = selectedColumns;
  }, [selectedColumns]);
  useEffect(() => {
    pinnedCountRef.current = pinnedCount;
  }, [pinnedCount]);

  useEffect(() => {
    dispatch(getColumnListing({ type: type, sub_type: subType }, { columns: columns }));
  }, []);

  useEffect(() => {
    if (typeof setSelectedColumns !== "function" || !selectedColumns?.length || !columns?.length) {
      return;
    }
    const filteredSelectedColumns = filterSelectedColumns(selectedColumns);
    if (filteredSelectedColumns.length !== selectedColumns.length) {
      setSelectedColumns(filteredSelectedColumns);
    }
  }, [columns, selectedColumns]);

  useEffect(() => {
    if (isDragged) {
      const currentSelected = selectedColumnsRef.current || selectedColumns;
      const selectedColumnsToSave = filterSelectedColumns(currentSelected);
      dispatch(
        setColumnListing(
          { type, sub_type: subType, force: 1, validate_columns },
          { selectedColumns: selectedColumnsToSave, pinnedCount: pinnedCountRef.current }
        )
      );
      setIsDragged?.(false);
    }
  }, [isDragged]);

  useEffect(() => {
    if (columnSelection) {
      const currentSelected = selectedColumnsRef.current || selectedColumns;
      const selectedColumnsToSave = filterSelectedColumns(currentSelected);
      dispatch(
        setColumnListing(
          { type, sub_type: subType, force: 1, validate_columns },
          { selectedColumns: selectedColumnsToSave, pinnedCount: pinnedCountRef.current }
        )
      );
      setColumnSelection?.(false);
    }
  }, [columnSelection]);
}
